<template>
    <router-link :to="link" class="preview">
        <h2 v-text="title"></h2>
        <span class="date" v-text="publishedDate"></span>
        <img :src="imgUrl" alt="">
        <div class="excerpt" v-html="excerpt"></div>
    </router-link>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "PagePreview",
        props: {
            page: { required: true },
        },
        computed: {
            excerpt() {
                if( this.pageObj == null ) {
                    return ""
                }
                return this.pageObj.excerpt.rendered
            },
            imgUrl() {
                if( this.pageObj == null ) {
                    return ""
                }
                return this.pageObj.images.medium
            },
            link() {
                if( this.pageObj == null ) {
                    return ""
                }
                return {
                    name: 'post',
                    params: {slug: this.pageObj.slug},
                }
            },
            pageObj() {
                return this.$store.getters['pages/id'](this.page.id)
            },
            publishedDate() {
                if( this.pageObj == null ) {
                    return null
                }
                let d = moment(this.pageObj.date)
                return d.locale('pt').format("DD MMM YYYY")
            },
            title() {
                return this.page.title
            },
        },
        watch: {
            pageObj: {
                immediate: true,
                handler() {
                    if( this.pageObj != null ) {
                        return
                    }
                    this.$store.dispatch('pages/getOne', {id: this.page.id})
                },
            },
        },
    }
</script>

<style scoped lang="scss">
.preview {
    display: grid;
    grid-template-columns: 1fr min-content;
    grid-template-rows: min-content min-content 1fr;
    gap: 0 1rem;
    grid-template-areas: 
        "title img"
        "date img"
        "excerpt img"
        ;

    h2 {
        grid-area: title;
        margin-bottom: 0;
    }

    img {
        grid-area: img;
        height: 12rem;
        width: auto;
    }

    span {
        grid-area: date;
        margin-bottom: .5em;
        font-size: .9rem;
    }

    .excerpt {
        grid-area: excerpt;
    }
}
</style>
